import { FC, ReactNode } from "react";
import { Box } from "@mui/material";
import SideBar from "./sideBar";
import Header from "./header";

interface PageContainerProps {
  children: ReactNode;
  isWide?: boolean;
  onlyContent?: boolean;
  displayBottomNavi?: boolean;
}

const PageContainer: FC<PageContainerProps> = (props) => {
  const { children, onlyContent = true, isWide = false } = props;
  const isPhone = false; //useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <Box
      display={"flex"}
      // alignItems={"stretch"}
      width={"100vw"}
      sx={{
        overflowY: "hidden",
      }}
      height={"100vh"}
    >
      {!isPhone && onlyContent && <SideBar />}
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexGrow={1}
        width="100%"
        height={"100vh"}
        // minWidth={isPhone ? "0" : "960px"}
        sx={{
          backgroundColor: "#FFFFFF",
          overflowY: "scroll",
          overflowX: "auto",
          // paddingBottom: isPhone && props.displayBottomNavi ? "56px" : "0",
        }}
      >
        {isPhone && onlyContent && <Header />}
        <Box
          width={isWide ? "1500px" : "1148px"} // isWide に基づいて maxWidth を動的に設定
          marginInline={"auto"}
          paddingInline={isPhone ? 2 : 3}
          paddingBlock={isPhone ? 2 : 5}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"flex-start"}
          flexGrow={1}
          gap={isPhone ? 0 : 3}
        >
          {children}
        </Box>
      </Box>
      {/* {isPhone && onlyContent && <BottomNavi />} */}
    </Box>
  );
};

export default PageContainer;
